import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { paymentMethodApiService } from "../services/paymentMethodApiService";
import { fromPaymentMethodsDtoToPaymentMethods } from "../types/paymentMethodTypes";

export const paymentMethodKeys = {
  client: (businessId: string, clientId: string, userId: string) => ["payment-methods", businessId, clientId, userId] as const,
};
export function usePaymentMethods(businessId: string, clientId: string, userId: string, enabled = true) {
  return useQuery({
    enabled,
    queryKey: paymentMethodKeys.client(businessId, clientId, userId),
    queryFn: async ({ signal }) => fromPaymentMethodsDtoToPaymentMethods(
      await paymentMethodApiService.getByClientId(businessId, clientId, signal)),
    staleTime: 0, retry: false,
  });
}
export function useRemovePaymentMethod(businessId: string, clientId: string, userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { action: "payment_method.remove" },
    mutationFn: (paymentMethodId: string) => paymentMethodApiService.remove(businessId, clientId, paymentMethodId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: paymentMethodKeys.client(businessId, clientId, userId) }),
  });
}
